<template>
  <SoAdminPageWithTabs :tabs="tabs" header-color="earth-light">
    <template #title>
      <h1 class="text-black d-flex align-center text-uppercase">trades</h1>
    </template>
    <template #tab-0>
      <ElecTradingTable />
    </template>
    <template #tab-1>
      <GasTradingTable />
    </template>
    <template #tab-2>
      <ElecNominationsForm />
    </template>
  </SoAdminPageWithTabs>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAdminPageWithTabs from "@/components/templates/SoAdminPageWithTabs.vue"
  import ElecTradingTable from "./components/ElecTradingTable.vue"
  import GasTradingTable from "./components/GasTradingTable.vue"
  import ElecNominationsForm from "@/views/operations/tradingData/components/ElecNominationsForm.vue"
  import { ITab } from "@/types/Tabs"

  export default defineComponent({
    components: {
      ElecNominationsForm,
      SoAdminPageWithTabs,
      ElecTradingTable,
      GasTradingTable,
    },
    data() {
      return {
        tabs: [
          {
            title: "Electricity Trades",
            icon: "electric",
            iconColor: "electric",
          },
          {
            title: "Gas Trades",
            icon: "gas",
            iconColor: "gas",
          },
          {
            title: "Electricity Nominations",
            icon: "upload",
          },
        ] as ITab[],
      }
    },
  })
</script>
